import * as moneyNumeral from "numeral";
import { RawNumberFormatter } from "./number_formatter.js";

// TODO: Document it
class MoneyFormatter extends RawNumberFormatter {

  format(value, format = undefined) {
    if(value === null || value === undefined) {
      return "";
    }
    let stringValue = `${value}`.replace(".", ",");
    let number = moneyNumeral(stringValue);
    if(format) {
      return number.format(format);
    }
    return number.format(`0,0[.][00]`);
  }
}

const instance = new MoneyFormatter();
export default instance;